import styles from "./styles/time-left-box.module.scss";

interface TimeLeftBoxProps {
  title: string;
  value: number | undefined;
}

const TimeLeftBox = ({ title, value }: TimeLeftBoxProps) => {
  return (
    <div className={styles.time_left_item}>
      <div className={styles.time_left_date_count}>{value}</div>
      <div className={styles.time_title}>{title}</div>
    </div>
  );
};

export default TimeLeftBox;
